import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map , catchError } from 'rxjs/operators';

// Modelos
import { Usuario } from '../models/usuario.model';
import { Aspirante } from '../models/aspirante.model';

// Config
import { URL_SERVICIOS } from '../config/config';

// Servicios
import { FiltrosPersistenciaService } from './filtros-persistencia.service';
// mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
import { ThemeService } from './theme.service';
@Injectable({
  providedIn: 'root'
})

export class UsuarioService {

  usuario : Usuario;
  token: string;
  login : boolean ;
  menu: any[] = [];

  constructor(public http: HttpClient,
              private filtrosPersistencia: FiltrosPersistenciaService,
              // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
              private theme: ThemeService) {
    this.CargarStorage();
   }

   CargarStorage(){
    if ( localStorage.getItem('JWT')) {
      this.token = localStorage.getItem('JWT');
      this.usuario = JSON.parse( localStorage.getItem('usuario') );
      this.menu = JSON.parse( localStorage.getItem('menu') );
      this.login = (localStorage.getItem("login") == "S");
    } else {
      this.token = '';
      this.usuario = new Usuario();
      this.menu = [];
      this.login = false;
    }

   }

   GuardarStorage( id: string, token: string, usuario: Usuario, menu: any ) {
    localStorage.setItem('S00USR', id );
    localStorage.setItem('JWT', token );
    localStorage.setItem('usuario', JSON.stringify(usuario) );
    localStorage.setItem('menu', JSON.stringify(menu) );
    localStorage.setItem("login",(this.login ? "S" : "N"));

    this.usuario = usuario;
    this.token = token;
    this.menu = menu;
  }

   EstaLogueado() {
      return this.login;
   }

  // almora 2026.03.14 Login con Microsoft Entra-ID 
  LoginMicrosoft (params) {
    let url = URL_SERVICIOS + "api/publicos/LoginMicrosoft";
    return this.http.post( url, JSON.stringify(params))
                .pipe(map( (resp: any) => {
                  this.login = true;
                  this.GuardarStorage( resp.S00ARC.S00USR, resp.S00ARC.JWT, resp.S00ARC, null);
                  // mospina 20-10-26 EPT-2594 Logout Microsoft: se guardan los datos de la sesion de Microsoft
                  localStorage.setItem('MSFT_ACCOUNT_ID', resp.S00ARC.MSFT_ACCOUNT_ID ?? resp.MSFT_ACCOUNT_ID ?? '');
                  localStorage.setItem('MSFT_ID_TOKEN',   resp.S00ARC.MSFT_ID_TOKEN   ?? resp.MSFT_ID_TOKEN   ?? '');
                  // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
                  this.theme.aplicarDesdeLogin(resp, false);   // Tema de la compañía (si no viene, conserva el de la pantalla de login)
                  return true;
                }),
                catchError( error => {
                  return throwError(error) ;
                }));
   }

   Login (usuario: Usuario):Observable<boolean>{
    let url = URL_SERVICIOS + 'api/login';
    return this.http.post( url, usuario )
                .pipe(map( (resp: any) => {
                  this.login = true;
                  this.GuardarStorage( resp.S00ARC.S00USR, resp.S00ARC.JWT, resp.S00ARC, resp.MENU);
                  // mospina 20-10-26 EPT-2594 Logout Microsoft: login normal, sin sesion de Microsoft
                  localStorage.removeItem('MSFT_ACCOUNT_ID');
                  localStorage.removeItem('MSFT_ID_TOKEN');
                  // mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR
                  this.theme.aplicarDesdeLogin(resp, false);   // Tema de la compañía (si no viene, conserva el de la pantalla de login)
                  return true;
                }),
                catchError( error => {
                  return throwError(error) ;
                }));
   }

   Salir(){
      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append ("Authorization", "Bearer " + this.token);
      // mospina 20-10-26 EPT-2594 Logout Microsoft: con sesion de Microsoft se usa logout2/{idToken}/{accountId}
      const msftAccountId = localStorage.getItem('MSFT_ACCOUNT_ID');
      const msftIdToken   = localStorage.getItem('MSFT_ID_TOKEN');
      let url = URL_SERVICIOS + 'api/publicos/logout';
      if (msftAccountId && msftIdToken) {
        url = URL_SERVICIOS + 'api/publicos/logout2/' + encodeURIComponent(msftIdToken) + '/' + encodeURIComponent(msftAccountId);
      }
      return this.http.post( url, this.usuario, { headers : headers } )
            .pipe(map( (resp: any) => {
             this.login = false;
             this.usuario = new Usuario();
             this.token = '';
             this.menu = [];

             localStorage.removeItem('JWT');
             localStorage.removeItem('S00USR');
             localStorage.setItem('usuario', JSON.stringify(this.usuario) );
             localStorage.removeItem('menu');
             localStorage.removeItem('automatricula_data') ;
             // mospina 20-10-26 EPT-2594 Logout Microsoft
             localStorage.removeItem('MSFT_ACCOUNT_ID');
             localStorage.removeItem('MSFT_ID_TOKEN');
             localStorage.setItem("login", "N");

             // almora 2026.05.26 — limpiar filtros persistentes (globales + particulares
             // de todas las pantallas) para que el siguiente usuario en un equipo
             // compartido no herede los filtros del anterior.
             this.filtrosPersistencia.limpiarTodo();

              return true;
            }),
            catchError( error => {
              return throwError(error) ;
            }));
    }

    getS00USR() {
      return this.usuario.S00USR;
    }

    getM12CAR() {
      return this.usuario.M12CAR;
    }

    getS00NOM() {
      return this.usuario.S00NOM;
    }
    getPAD10COD() {
      return this.usuario.PAD10COD;
    }

  CrearCuenta(aspirante:Aspirante):Observable<boolean>{
    let url = URL_SERVICIOS + 'api/registro/RegistroPrevio';
    return this.http.post( url, aspirante )
                .pipe(map( (resp: any) => {
                  return true;
                }),
                catchError( error => {
                  //error.error.message
                  return throwError(error) ;
                }));
  }

  CrearSolicitudClave(aspirante:Aspirante):Observable<boolean>{
    let url = URL_SERVICIOS + 'api/registro/SolicitudContrasena';
    return this.http.post( url, aspirante )
                .pipe(map( (resp: any) => {
                  return true;
                }),
                catchError( error => {
                  return throwError(error) ;
                }));
  }

  ActivarCuenta (sooema:string,s00cla:string, s34con: string, pad17con:string,pad10cod:string, pad17num:string) : Observable<any>{
    let url = URL_SERVICIOS + 'api/registro/ActivarCuenta?intS34CON='+s34con+'&intPAD17COD='+pad17con+'&intPAD10TMP='+pad10cod+'&strPAD17NUM='+pad17num;
    let json = {S00EMA: sooema,S00CLA:s00cla};
    return this.http.post( url,  JSON.stringify(json))
                .pipe(map( (resp: any) => {
                  return true;
                }),
                catchError((error: any) => {
                  let mensaje = 'Error desconocido';
                  if (error) {
                    if (error.error) {
                      if (typeof error.error === 'string') {
                        try { mensaje = JSON.parse(error.error).message || error.error; } catch { mensaje = error.error; }
                      } else if (typeof error.error === 'object') {
                        mensaje = error.error.message || JSON.stringify(error.error);
                      }
                    } else if (error.message) {
                      mensaje = error.message;
                    } else if (error.statusText) {
                      mensaje = error.statusText;
                    } else {
                      try { mensaje = JSON.stringify(error); } catch {}
                    }
                  }
                  return throwError(() => mensaje); 
                })
              );

  }

}
